import { render } from "./BandGoods.vue?vue&type=template&id=57255ca8"
import script from "./BandGoods.vue?vue&type=script&lang=js"
export * from "./BandGoods.vue?vue&type=script&lang=js"

import "./BandGoods.vue?vue&type=style&index=0&id=57255ca8&lang=scss"

import exportComponent from "D:\\xampp\\htdocs\\JuHui\\ju-hui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__